<script setup>
import { ref, onMounted } from "vue";
import { Download } from "@element-plus/icons-vue";
import VueQrcode from 'vue-qrcode'
const bool =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
const appUrl = ref(window.location.href);
const iosAPP = ref("https://novabeats.onelink.me/yKeA/ez2wo0q8");
const urlList = [
  "media.nova-beats.com",
  "media.novabeatsapp.com",
  "media.nova-beats.net",
  "media.nova-beatsapp.com",
  "media.novabeatsvip.com",
];
const handleAPPstore = () => {
  // eslint-disable-next-line no-undef
  window.open(iosAPP.value);
  // window.open(
  //   "https://apps.apple.com/us/app/novabeats-audiobooks-series/id1613694158"
  // );
};

const handleGoogle = () => {
  window.open(
    "https://play.google.com/store/apps/details?id=com.bestnovel.reader&pli=1"
  );
};

const hanldeMobile = () => {
  if (bool) {
    handleAPPstore();
    // const downloadLink = window.navigator.userAgent.includes("iPhone");
    // downloadLink
    //   ? window.open(iosAPP.value)
    //   : window.open(
    //       "https://play.google.com/store/apps/details?id=com.bestnovel.reader&pli=1"
    //     );
  }
};

const onMouseEnter = () => {
  if (document.querySelector(".player")) {
    document.querySelector(".player").style.zIndex = -1;
  }
};

const onMouseLeave = () => {
  if (document.querySelector(".player")) {
    document.querySelector(".player").style.zIndex = 0;
  }
};
function getHrefUrl(url) {
  let urlData = "";
  urlList.forEach((item) => {
    if (url.indexOf(item) > -1) {
      urlData = item;
    }
  });
  return urlData;
}
onMounted(() => {
  switch (getHrefUrl(appUrl.value)) {
    case "media.nova-beats.com":
      iosAPP.value = "https://novabeats.onelink.me/yKeA/ez2wo0q8";
      break;
    case "media.novabeatsapp.com":
      iosAPP.value = "https://novabeats.onelink.me/yKeA/v2bnqrjh";
      break;
    case "media.nova-beats.net":
      iosAPP.value = "https://novabeats.onelink.me/yKeA/gftvggmw";
      break;
    case "media.nova-beatsapp.com":
      iosAPP.value = "https://novabeats.onelink.me/yKeA/td82740h";
      break;
    case "media.novabeatsvip.com":
      iosAPP.value = "https://novabeats.onelink.me/yKeA/z6xyh69d";
      break;
  }
});
</script>
<template>
  <div
    class="download"
    @click="hanldeMobile"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <el-icon class="downIcon"><Download /></el-icon
    ><span class="downText">Download</span>
    <div class="header-download-box" data-v-d2d0df0c="">
      <div class="header-download-title" data-v-d2d0df0c="">
        <img
          class="rounded-[8px]"
          src="../assets/logo.jpg"
          alt=""
          data-v-d2d0df0c=""
        />
        <div data-v-d2d0df0c="">
          <div class="header-download-title-name" data-v-d2d0df0c="">
            NovaBeats
          </div>
          <div class="header-download-title-intro" data-v-d2d0df0c="">
            Enjoy countless enchanting contents.
          </div>
        </div>
      </div>
      <div class="app-qr" data-v-41205dec="" data-v-d2d0df0c="">
        <div class="app-qr-item" data-v-41205dec="" @click="handleAPPstore">
          <vue-qrcode :value="iosAPP" class="app-qr-item-qr"></vue-qrcode>
          <div class="app-qr-item-bottom" data-v-41205dec="">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABgUExURUdwTPBqIzOoUjCmUaqEMN64D0eqS9VLTD2Px1Z83fikDfBnJepBM+REOjKoUvy8AjOoUjOoUu1gKfu8A1B/4+pCNOpCNO+7CPu8A/u8BEiMufq7AzSoU/u8A+pDNUKF9Bf0gj8AAAAcdFJOUwD86ykM/f39/P4iMnKxYGKUuEuD9OrTt+XH89s+4hPuAAAA70lEQVQ4y73UXReCIAwGYFLKAs20T43J//+XYSIHcENv6r1+ztnEbYz9Jnmjsku+wWXKJLvwNdioKdl5BfZqTpOur49OqmR97Ut1TsFA0q3qSJKt6oUkWtWIROtrTB6eLQUDedgDPAUBPTk6kyvHoZPWAbxqHFrpnEknUPiVvgN4cxQaGTqAGoe6jxxccXgqdpvgqRiGSAoMji6SNfbVk/NlJ7F3nJ2T4XuzpbMy+oMMcaNczATD3PCQxDyG7l5SEx66klM7E7hKkFt489yjpffac3hzNp6rkhetckymr1m72tyc8tsc33CbuZTs3/kAOplLAabVO/oAAAAASUVORK5CYII="
              alt=""
              data-v-41205dec=""
            />
            <div class="app-qr-item-right" data-v-41205dec="">
              <strong data-v-41205dec="">Google Play</strong>
            </div>
          </div>
        </div>
        <div class="app-qr-item" data-v-41205dec="" @click="handleAPPstore">
          <vue-qrcode :value="iosAPP" class="app-qr-item-qr"></vue-qrcode>
          <div class="app-qr-item-bottom" data-v-41205dec="">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH6NKgYAAAAMdFJOUwDjzjgPfa2SIvVsTZATm9cAAAD2SURBVCjPY2BAAu2qDBiA9cxRTMGcM6cxxNjPnJmCIWhz5kwBFt0nG9DFWOZgMZL5zMENmIKHQlAFOLYuBlFW5YsRYtw6Z86IN3AEnjlzRgpuRQ6Qd+agDog8owIVdDqDBA46wByIBE4aQExEFjsjAVHIhCJoAPczAsACLwZZcAoDFnsSoII6yIIBUEEZZMEF2AQDsGkvwGaRAFSwBlkQFvhrkAUPQQV7zmBxKCOK4DEHWCJABsLQaDyDxSoUh8IctecMFo8yYYsjZmyuR/ETLECR9cN0A1MNIvQmI9JNIzC+U5dmwmMdknAKJwGTHMsiwQoGnAAAotIxMJFG+w4AAAAASUVORK5CYII="
              alt=""
              data-v-41205dec=""
            />
            <div class="app-qr-item-right" data-v-41205dec="">
              <strong data-v-41205dec="">App Store</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@import "../assets/css/download.css";
</style>
